import '../../js/theme';
import './perguntas-frequentes.scss';

document.addEventListener('DOMContentLoaded', () => {
    loadAccordion();
  });
  /**
   * Carrega os scripts dos accordions
   */
  function loadAccordion() {
    const acc = document.getElementsByClassName('accordion');
    let i;
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener('click', function () {
        this.classList.toggle('active');
        const panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    }
  }
  